import { VISIBLE_PHONE_DIGITS } from '../constants/constants';

export const maskPhoneNumber = (phone) => {
    const visibleDigitsCount = parseInt(VISIBLE_PHONE_DIGITS, 10);
    if (phone && phone.length >= visibleDigitsCount) {
        const visibleDigits = phone.slice(-visibleDigitsCount);
        return 'X'.repeat(phone.length - visibleDigitsCount) + visibleDigits;
    }
    return phone;
};